import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {NotificationService} from "../service/notification.service";

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
    constructor(private notifService:NotificationService) {
    }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = localStorage.getItem(environment.TOKEN_KEY);
        // if (req.url.includes('/auth/login')) {
        //     return next.handle(req);
        // }
        // if (token) {
            // Ajouter le paramètre `token` dans l'URL
            const clonedReq = req.clone({
                setHeaders: {
                    Authorization: token ?? '',
                    type: 'WEB',
                    firebasetoken: this.notifService.getCurrentToken() ?? '',
                    identity: this.getCurrentHost(),
                }
            });
            return next.handle(clonedReq);
        // }
        // return next.handle(req);
    }

    getCurrentHost(){
        return window.location.hostname
    }
}
